var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 9,
    viewBox: "0 0 71 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.3499 4.84635C70.5452 4.65109 70.5452 4.33451 70.3499 4.13924L67.1679 0.957264C66.9726 0.762002 66.6561 0.762002 66.4608 0.957264C66.2655 1.15253 66.2655 1.46911 66.4608 1.66437L69.2892 4.4928L66.4608 7.32122C66.2655 7.51649 66.2655 7.83307 66.4608 8.02833C66.6561 8.22359 66.9726 8.22359 67.1679 8.02833L70.3499 4.84635ZM-0.00366211 4.9928H69.9963V3.9928H-0.00366211L-0.00366211 4.9928Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.a92c9ec14332074655c36195f6c69d7d.svg";
export { ForwardRef as ReactComponent };